module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"welcome_m":"Welcome","biography_m":"Biography","massages_m":"Massages","mission-n-vision_m":"Mission & Vision","booking_m":"Booking","social-media_m":"Social Media"},"fr":{"welcome_m":"Bienvenue","biography_m":"Biographie","massages_m":"Les massages","mission-n-vision_m":"La vision de la mission","booking_m":"Réservation","social-media_m":"Des médias sociaux"}}')
  delete Component.options._Ctor
}
